import qs from 'qs';

const Property = {
    namespaced: true,

    state: {
        propertyData: [],
    },

    getters: {
        propertyData (state) {
            return state.propertyData;
        },
    },

    mutations: {
        /**
         * Установить свойство
         * @param state
         * @param items
         */
        setArr (state, { items }) {
            state['propertyData'] = items;
        },

        /**
         * Обновить свойство
         * @param state
         * @param item
         * @param index
         */
        setItem (state, { item, index }) {
            state['propertyData'][index] = item;
        },

        /**
         * Добавить свойство
         * @param state
         * @param item
         */
        addItem (state, { item }) {
            state['propertyData'].push(item);
        },

        /**
         * Удалить свойство
         * @param state
         * @param item
         */
        remove (state, { item }) {
            state['propertyData'] = state['propertyData'].filter(iItem => iItem !== item);
        },
    },


    actions: {
        /**
         * Получение данных по свойствам
         * @param commit
         * @param dispatch
         * @param getters
         * @param rootGetters
         * @returns {Promise<any>}
         */
        getPropertyData ({ commit, dispatch, getters, rootGetters }) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                axios({
                    url: rootGetters.rootUrl + 'list/index',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.property,
                    }),
                }).then(response => (
                    commit('setArr', {
                        items: response.data
                    }),
                    dispatch('loading/isLoading', false, {root:true}),
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные по свойствам получены.'),
                    resolve(response)
                )).catch(err => {
                    dispatch('loading/isLoading', false, {root:true}),
                    console.log('ERROR IN property.js | getPropertyData: ' + err);
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка в получении данных по свойствам!'),
                    reject(err);
                });
            })
        },

        /**
         * Сохранение данных по свойствам
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */
        savePropertyData ({ commit, dispatch, getters, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});

                const str = JSON.stringify(data.data);

                axios({
                    url: rootGetters.rootUrl + 'list/save',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': str,
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.property,
                    }),
                }).then(response => {
                    // Если редактирование
                    if (data.index !== -1) {
                        commit('setItem', {
                            item: data.data,
                            index: data.index
                        });
                        dispatch('loading/isLoading', false, {root:true});
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные по свойствам успешно отредактированы!');
                    // Если сохранение нового
                    } else {
                        data.data.id = response.data[0].id;

                        commit('addItem', {
                            item: data.data
                        });
                        dispatch('loading/isLoading', false, {root:true});
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Новое свойство успешно создано!');
                    }
                    resolve(response);
                }).catch(err => {
                    dispatch('loading/isLoading', false, {root:true});
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при сохранении данных!');
                    console.log('ERROR IN property.js | savePropertyData: ' + err);
                    reject(err);
                })
            })
        },

        /**
         * Удаление свойства
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */
        removePropertyData ({ commit, dispatch, getters, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                const str = JSON.stringify(data.item);
                axios({
                    url: rootGetters.rootUrl + 'list/delete',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': str,
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.property,
                    }),
                }).then(response => (
                    commit('remove', {
                        item: data.item
                    }),
                    dispatch('loading/isLoading', false, {root:true}),
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Свойство успешно удалено!'),
                    resolve(response)
                )).catch(err => {
                    dispatch('loading/isLoading', false, {root:true});
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при удалении свойства!'),
                    console.log('ERROR IN property.js | removePropertyData: ' + err);
                    reject(err);
                });
            })
        },
    },
};

export default Property;


// WEBPACK FOOTER //
// ./src/store/modules/property.js